module.exports = __webpack_public_path__ + "public/images/Testimonial_Shauna.5a8f69ee6c839f1b77e1cde8dabe781c.webp";